import type { TimeFormat } from '../types'
import { startOfToday, format, addSeconds } from 'date-fns'

export function formatTime(value: number, timeFormat: TimeFormat): string {
  const start = startOfToday()
  return format(addSeconds(start, value), timeFormat)
}
